import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { UpsertSeasonEntityModel } from "~pages/SeasonEntities/types/upsertSeasonEntityModel";
import type { SeasonEntityResponse } from "~types/seasonEntity.ts";

export const useUpsertSeasonEntity = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<SeasonEntityResponse, Error, UpsertSeasonEntityModel>({
    mutationFn: async ({ entityId, ...upsertData }) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities?include=seasons,entities,conferences,divisions`, {
        method: "POST",
        body: {
          entityId,
          ...upsertData,
        },
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "seasonEntity.update.success" }),
        placement: "bottomRight",
      });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["seasonEntities", sport, organizationId, seasonId] }),
        queryClient.invalidateQueries({ queryKey: ["seasonEntity", sport, organizationId, seasonId] }),
      ]);
    },
  });
};
